import Request from './request';

export const getData = async (currentTab: string) =>
  Request.call({
    url: `/${currentTab}?per_page=100`,
    method: 'GET',
  });
